import * as Yup from 'yup';
import { createSortSchema, createPaginationSchema } from '@emfood/shared';

export const FinanceOrdersListFilterSchema = Yup.object({
  distributorOrgId: Yup.string().optional(),
  distributorSiteId: Yup.string().optional(),
  buyerSiteId: Yup.string().optional(),

  deliveryDateFrom: Yup.date().optional().nullable(),
  deliveryDateTo: Yup.date()
    .optional()
    .nullable()
    .when('deliveryDateFrom', {
      is: (value: any) => value != null,
      then: (schema) =>
        schema.min(
          Yup.ref('deliveryDateFrom'),
          'deliveryDateTo must be on or after deliveryDateFrom'
        ),
    }),
});

// Pick date related filters for use with React Hook Form (only the date filters need validation)
export const FinanceDateFilterSchema = FinanceOrdersListFilterSchema.pick([
  'deliveryDateFrom',
  'deliveryDateTo',
]);

export type FinanceDateFilterModel = Yup.InferType<typeof FinanceDateFilterSchema>;

const FinanceSearchParams = createPaginationSchema().concat(
  createSortSchema(
    ['orderReferenceNumber', 'orderReference', 'createdOn', 'deliveryDate'] as const,
    {
      defaultSortBy: 'createdOn',
      defaultSortOrder: 'desc',
    }
  ).concat(FinanceOrdersListFilterSchema)
);

export default FinanceSearchParams;
